
// USA
export const locale = {
  lang: 'en',
  data: {
    mare: 'mare',
    gelding: 'gelding',
    stallion: 'stallion',
    maintenance: {
      title: 'Maintenance',
      message:
        'Our website is currently undergoing maintenance. Please visit again later. Thank you for your understanding.',
    },
    GENERAL: {
      RACES: 'Races',
      DELETE: 'Delete',
      ONE_MOMENT: 'One moment please...',
      CLOSE: 'Close',
      PRINT: 'Print',
      RESULT: 'Result',
      TEMPORARY_RESULT: 'Temporary Result',
      SELECT: 'Select your language',
      LANGUAGE: 'Language',
    },
    MENU: {
      HOME: 'HOME',
      ALL_RACES: 'ALL RACES',
      ALL_RACES_SHORT: 'ALL',
      PMU_RACES: 'PMU RACES',
      PMU_RACES_SHORT: 'PMU',
      NEXT_RACES: 'NEXT RACES',
      NEXT_RACES_SHORT: 'NEXT',
      STREAMING: 'Live Streaming',
    },
    BETTING_SLIP: {
      YOUR_BETTING_SLIP: 'Your Betting Slip',
    },
    HOME: {
      CALENDAR: 'Calendar',
      TODAY: 'Today',
      YESTERDAY: 'Yesterday',
      TOMORROW: 'Tomorrow',
      COUNTRIES: 'Countries',
      NEXT_BETTING: 'Next betting opportunities',
      NEXT_PMU_BETTING: 'PMU next races',
      MORE: 'MORE',
      JACKPOT: 'Jackpot',
      ACCUMULATOR_TITLE: 'Bet Box/accumulator bet',
      ACCUMULATOR_DESC:
        'No horse selected for the accumulator bet. Click on the tote odds in the race.',
      STARTER_SEARCH: 'Starter search',
      SEARCH: 'Search',
      HEAD_TO_HEAD: 'Head to Head',
      HEAD_TO_HEAD_DESC: 'There are no Head to Head pairings available today.',
      HIGHLIGHTS: 'Highlights',
      STARTER_INDEX: 'Starter index',
      LOGIN: 'LOG IN',
      LOGOUT: 'Logout',
      STARTING: 'Starting...',
      STARTING_SHORT: 'Starting...',
      IN: 'in',
      MAINTANANCE:
        'OUR PLATFORM WILL BE UNAVAILABLE ON TUESDAY, 08/11/2022, BETWEEN 23:00 - 02:00 CEST DUE TO MAINTENANCE',
      NOT_SHOW: 'Not show again.',
    },
    RACES: {
      MANUALREVIEW: 'Manual Review',
      CANCELREASON: 'Cancel Reason',
      COMBINAISON: 'Combination',
      PRIZE_MONEY: 'Prize Money',
      DISTANCE: 'Distance',
      SOIL: 'Soil',
      STARTERS: 'Starters',
      RESULT: 'Result',
      STARTED: 'Started',
      BETTING_SLIP: 'Betting slip',
      START_TYPE: 'Start type',
      NON_STARTERS: 'Non-starters',
      TYPE_OF_BET: 'Type of Bet',
      STAKES: 'Stakes',
      STAKE: 'Stake',
      TIME_RACE: 'Time/Race',
      MARKINGS: 'Markings',
      EV: 'EV',
      WIN: 'Win',
      BET: 'Bet',
      NEW: 'New',
      NUMBER_OF_BETS: 'Number of bets',
      PLACE_BET: 'Place Bet',
      PLACE_BET_PRINT: 'Place Bet',
      PAY_FOR_BET: 'Pay for Bet',
      CONFIRM_TEXT: 'The total cost of this bet is',
      POTENTIAL_WINNINGS: 'Potential winnings',
      TOTAL_STAKES: 'Total Stakes',
      TOTAL_PRICE: 'Total Price',
      STAKES_IN: 'Stakes in',
      RACING_CLUB: 'Racing Club',
      MORE_BOOKIE_BETS: 'More Bookie Bets',
      BOOKMAKER: 'Bookmaker',
      FIXED_ODDS_BET: 'Fixed-odds bet',
      SHOW_BETTING_SLIP: 'Show betting slip',
      HIDE_BETTING_SLIP: 'Hide betting slip',
      MY_BETS: 'My Bets',
      WINNINGS: 'Winnings',
      TOP_WINNINGS: 'Winnings',
      NUMBER: 'Number',
      OPEN: 'Open',
      LOST: 'Lost',
      WON: 'Won',
      CANCELED: 'Canceled',
      REFUND: 'Refund',
      CANCEL: 'Cancelled',
      CASHBACK: 'Cashback',
      STATUS: 'Status',
      HORSE: 'Horse',
      FORM: 'Form',
      WEIGHT: 'Weight',
      TRAINER: 'Trainer',
      SP: 'SP',
      FIXED_ODDS: 'Fixed Odds',
      ORIGIN: 'Origin',
      LINEAGE: 'Lineage',
      OWNER: 'Owner',
      AGE: 'Age',
      JOCKEY: 'Jockey',
      PLACE: 'Place',
      TOTAL: 'Total',
      TOTAL_WON: 'Total Won',
      TOTAL_LOST: 'Total Lost',
      TOTAL_BETS: 'Total Bets',
      TOTAL_CANCELED: 'Total Canceled',
      TOTAL_REFUND: 'Total Refund',
      TOTAL_CASHBACK: 'Total Cashback',
      DATE: 'Date',
      RACE: 'Race',
      RACE_C: 'Race',
      RACE_LOCATION: 'Race Location',
      BET_TYPES: 'Bet types',
      CONFIRM_YOUR_BET: 'Confirm Your Bet',
      GO_TO_RACE: 'Go to Race',
      DOG: 'Dog',
      DRIVER: 'Driver',
      RECORD_TIME: 'Record time',
      NO_OF_STARTS: 'No. of starts',
      NO_OF_WINS: 'No. of wins',
      NO_OF_PLACES: 'No. of places',
      QUINELLA: 'Quinella',
      SWINGER: 'Swinger',
      QUINELLA_SWINGER: 'Quinella/Swinger',
      EXACTA: 'Exacta',
      QUINTE: 'Quinte+ Champ',
      'QUINTÉ+': 'Quinte+',
      'QUINTÉ+_7': 'Quinte Order',
      'QUINTÉ+_6': 'Quinte Disorder',
      'QUINTÉ+_4': 'Quinte Order',
      'QUINTÉ+_3': 'Quinte Order',
      'QUINTÉ+_2': 'Quinte Disorder',
      'QUINTÉ+_1': 'Quinte Bonus 4',
      'QUINTÉ+_0': 'Quinte Bonus 3',
      QUINTE_STANDARD: 'Quinte Standard',
      TRIFECTA: 'Trifecta',
      TIERCE: 'Tiercé Champ',
      'TIERCÉ_-1': 'Tiercé Order',
      TIERCÉ: 'Tiercé',
      TIERCÉ_1: 'Tiercé Order',
      TIERCÉ_0: 'Tiercé Disorder',
      'TIERCÉ CHAMP_0': 'Tiercé Disorder',
      'TIERCÉ CHAMP_1': 'Tiercé Order',
      TIERCE_STANDARD: 'Tiercé Standard',
      'TIERCÉ STANDARD': 'Tiercé Standard',
      QUARTE: 'Quarté Champ',
      // 'QUARTÉ+': 'Quarté+',
      'QUARTÉ+_-1': 'Quarté Order',
      'QUARTÉ+_2': 'Quarté Order',
      'QUARTÉ+_1': 'Quarté Disorder',
      'QUARTÉ+_0': 'Quarté Bonus',
      'QUARTÉ+ CHAMP_0': 'Quarté Bonus',
      'QUARTÉ+ CHAMP_1': 'Quarté Disorder',
      'QUARTÉ+ CHAMP_2': 'Quarté Order',
      QUARTE_STANDARD: 'Quarté Standard',
      // 'QUARTÉ+ STANDARD': 'Quarté Standard',
      WIN_PLACE: 'Win/Place',
      AMOUNT: 'Amount',
      BALANCE: 'Balance',
      PROFIT_FROM_BETTING: 'Profit from betting',
      DEPOSIT: 'Deposit',
      WITHDRAWAL: 'Withdrawal',
      FINISH: 'Finish',
      RACE_NR: 'Race Nr.',
      RACE_NR_C: 'Race Nr.',
      ODDS: 'Odds',
      R: 'R',
      ALL: 'All',
      CANCELLATIONS: 'Cancellations',
      BETS: 'Bets',
      NOT_FOUND_RACE: 'Race not found.',
      CURRENT_FIXED_ODDS: 'Current fixed odds',
      J: 'J.',
      MARE: 'mare',
      STALLION: 'stallion',
      GELDING: 'gelding',
      T: 'E',
      NO_BET: 'You have not bet on this race yet',
      CANCEL_COUPON: 'Cancel Coupon',
      COUPON_CANCELLED_MESSAGE:
        '{{betSlipId}} coupon has been successfully canceled',
      COUPON_CANCELLED_ERROR_MESSAGE:
        'Coupon cancellation limit has been exceeded',
      SHOW_CHAT: 'Show Chat',
      HIDE_CHAT: 'Hide Chat',
      STARTING: 'Starting',
    },
    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
        MY_ACCOUNT: 'My Account',
      },
      MENU: {
        ACCOUNT: 'Account',
        BETS: 'Bets',
        PROFILE: 'Profile',
      },
      ACCOUNT: {
        YOUR_CURRENT_ACCOUNT: 'Your current account status as of {{date}}',
        RECENT_TRANSACTIONS: 'Recent transactions on your betting account.',
        AVAILABLE_FOR_WITHDRAWAL: 'Available for withdrawal',
        ANY_TRANSACTION: 'You do not have any transaction.',
      },
      BET: {
        NO_BET_HISTORY: 'No bet history currently available.',
      },
      ACTIVATION: {
        TITLE: 'Activation Complete',
        PASSWORD_REQUIRED: 'You are required to change the password.',
        EMAIL_OPTIONAL:
          'Email address is optional, but we strongly recommend that you enter and activate the email you actively use. ',
        COMPLETE: 'Complete',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        FORGOT_PASSWORD: 'Forgot password?',
        RESET_PASSWORD: 'RESET PASSWORD',
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
      },
      INPUT: {
        USERNAME: 'Username',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        NEW_PASSWORD: 'New Password',
        CONFIRM_NEW_PASSWORD: 'Confirm New Password',
        EMAIL: 'Email Address',
        CONFIRM_EMAIL: 'Confirm Email Address',
      },
      VALIDATION: {
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      },
    },
    ALERT: {
      SUCCESSFULLY_CREATED: 'The bet has been successfully created',
      USERNAME_NOTFOUND: 'Username not found',
      USERNAME_OR_PASSWORD_IS_INCORRECT:
        'Something went wrong, The username or password is incorrect. Please try again.',
      PASSWORD_IS_INCORRECT: 'The password is incorrect. Please try again.',
      PASSWORD_MUST_MATCH: 'Passwords must match.',
      ONLY_VALID_BETS_ARE_ALLOWED: 'Only valid bets are allowed',
      RACE_IS_STARTED: 'Race is started',
      STAKE_ERROR: 'Stake error',
      INSUFFICIENT_BALANCE: 'Insufficient balance',
      USER_ACCOUNT_UPDATED: 'User account has been successfully updated',
      SOMETHING_WENT_WRONG: 'Something went wrong',
      USER_PASSWORD_UPDATED: 'User password has been successfully updated',
      PASSWORD_SUCCESSFULLY_RESET: 'Your password was successfully reset',
      ACTIVATION_SUCCESSFULLY_COMPLETE_EMAIL:
        'User activation has been successfully complete. Please verify your email address',
      ACTIVATION_SUCCESSFULLY_COMPLETE:
        'User activation has been successfully complete',
      MUST_BE_FILLED_CORRECTLY: '{{invalids}} must be filled correctly!',
      VERIFY_YOUR_EMAIL: 'Please verify your email address',
      WELCOME: 'Welcome',
      EMAIL_SUCCESSFULLY_VERIFIED: 'Your email was successfully verified.',
      MONEY_HAS_BEEN_DEPOSITED: 'Money has been deposited into your account.',
      Please_refresh_the_page_to_print: 'Please refresh the page to print',
      INVALID_PHONE: 'Invalid Phone number',
      OUT_OF_ORDER: 'Your account has been temporarily disabled.',
    },
    QUARTE_RACES: {
      HEADER_TITLE: "Today's Quarté races",
      FINISHED: 'Finished',
      NO_RACE: 'Does not exist yet',
    },
    TRACK_RACES: {
      YEARS_OLD_HORSES: 'For {{year}} years old Horses',
      YEARS_OLD_AND_UPWARD_HORSES: 'For {{year}} years old and upward Horses',
    },

    Next_Races_Seo: {
      title: 'Next Races | Horse Racing Betting | Bet Online with Racebet365',
      description_content:
        "Don't miss the next race on Racebet365! With our 24/7 betting, you can keep up with races worldwide and place your bets on your favorite races.",
      keywords_content:
        'next race, races, Racebet365, betting, worldwide, 24/7, keeping up, favorite races.',
    },

    HomePage_Seo: {
      title: 'Horse Racing Betting | Bet Online with Racebet365',
      description_content:
        'The ultimate online destination for horse race betting around the world! We offer a wide range of bet types for horse racing events, along with a cashback that guarantees your satisfaction. Join Racebet365.com today and discover the thrill of online horse race betting like never before!',
      keywords_content:
        'Online horse race betting, Bet on horse races, Online betting site, Horse race gambling, Worldwide horse racing, PMU Races',
    },

    All_Races_Seo: {
      title: 'All Races | Horse Racing Betting | Bet Online with Racebet365',
      description_content:
        'Discover all races worldwide and place your bets on Racebet365! We offer a wide selection from horse racing to dog racing.',
      keywords_content:
        'races, horse racing, dog racing, Racebet365, betting, UK, USA, Australia, popular races, combinations.',
    },

    Pmu_Races_Seo: {
      title: 'PMU Races | Horse Racing Betting | Bet Online with Racebet365',
      description_content:
        'Explore PMU races and place your bets on Racebet365! Exciting races await you with betting combinations like Win, Place, Ita, Trita, Jumele, Exacta, Trio, Trifecta, Tierce, and Quatre.',
      keywords_content:
        'PMU, race, Racebet365, betting, Gagnant, Place, Ita, Trita, Jumele, Exacta, Trio, Trifecta, Tierce, Quatre.',
    },

    Next_Betting_Seo: {
      description_content: 'Find the list of the next races available...',
      keywords_content: ' NEXT BETTING OPPORTUNITY',
    },

    Track_Races_Seo: {
      description_content: ' Find the list of races available in Vincennes',
      keywords_content: 'VINCENNES RACES 06/29/2022',
    },

    Account_Page_Seo: {
      description_content: 'View your transaction history',
      keywords_content: 'TRANSACTION HISTORY',
    },

    Profile_Page_Seo: {
      description_content: 'Check your account information, change password.',
      keywords_content: 'MY PROFILE',
    },

    Bets_Page_Seo: {
      description_content: 'View your betting history',
      keywords_content: 'HISTORY OF BETS',
    },
    'Some coupons gave an error': 'Some coupons gave an error',
    'Something went wrong.': 'Something went wrong.',
    'Only valid bets are allowed': 'Only valid bets are allowed',
    'Total price error': 'Total price error',
    'Coupon was lost.': 'Coupon was lost.',
    'Insufficient balance': 'Insufficient balance',
    CRYPTO: {
      ONLY_SEND_TETHER_USDT: "ONLY send Tether (USDT)",
      TO_THIS_DEPOSIT_ADDRESS: "to this deposit address",
      DO_NOT_USE: "Do NOT use",
      DO_NOT_USE_ERC20: "ERC20, BEP2, BEP20, OMNI, SOL, or other network standards as you may lose your deposit.",
      ONLY_MAKE_DEPOSITS_THROUGH_THE_ETHEREUM_NETWORK_ERC20: "ONLY make deposits through the Ethereum (ERC20) network",
      ONLY_MAKE_DEPOSITS_THROUGH_THE_ETHEREUM_NETWORK: "ONLY make deposits through the Ethereum network",
      ONLY_MAKE_DEPOSITS_THROUGH_THE_TRON_TRC20_NETWORK: "ONLY make deposits through the Tron (TRC20) network.",
      DO_NOT_USE_BEP2_BEP20_OMNI_TRC20_SOL: "BEP2, BEP20, OMNI, TRC20, SOL or other network standards as you may lose your funds.",
      DO_NOT_USE_BEP2_BEP20: "BEP2, BEP20, or other network standards as you may lose your deposit.",
      THE_USE_OF_CONTRACT_ADDRESSES_IS_NOT_ALLOWED: "The use of contract addresses is not allowed.",
      ONLY_SEND_ETHEREUM_METH: "ONLY send Ethereum (mETH)",
      ONLY_SEND_BITCOIN_MICRONBTC: "ONLY send Bitcoin (µBTC)",
      DO_NOT_USE_LIGHTNING_NETWORK: "Lightning Network, BEP20, BEP2, ERC20, Polygon or other network standards as you may lose your deposit.",
      ONLY_MAKE_DEPOSITS_THROUGH_THE_BTC_NETWORK: "ONLY make deposits through the BTC network.",
      SELECT_YOUR_CRYPTO_CURRENCY_DEPOSIT_METHOD: 'Select your crypto currency deposit method',
      RISKS_CONFIRMATION: "By clicking the 'Confirm' button, you indicate that you agree to the above-mentioned risks.",
      DEPOSIT: "Deposit",
      WITHDRAWAL: "Withdrawal",
      COPY_ADDRESS_OR_SCAN_QR_CODE: 'Copy the address or scan the QR Code',
      MINIMUM_DEPOSIT_AMOUNT: 'Minimum deposit amount {{amount}}',
      NOTE_ABOUT_THE_EXCHANGE_RATE: 'Note about the exchange rate: Please note that the exchange rate at the completion of the transaction may differ slightly from the above.',
      TRANSACTION_COMPLETION: 'Transaction completion: Please note that after completing a transaction, it may take up to 15 minutes for the change to be visible in your account balance.',
    },
  },
 
};
